import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { CssBaseline } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import App from './App'
import './index.css'
import { store } from './store'
import theme from './theme/theme'

const container = document.getElementById('root')
// CRA's HTML shell always has #root — this is just defensive against a hand-edited index.html.
if (!container) {
  throw new Error('Root container missing in index.html')
}
const root = createRoot(container)

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
)
